<template>
  <div class="row">
    <card-default>
      <div
        slot="title"
        class="card-title"
      >
        <div class="row">
          <div class="col h4">
            Language: {{ languageCopy.code }}
          </div>
          <div class="col">
            <auth-button
              :permission="languageCopy.id ? 'language-update' : 'language-create'"
              class="btn btn-primary btn-micro float-right"
              @click="$emit('save', languageCopy)"
            >
              Save
            </auth-button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <auth-button
              v-if="languageCopy.id"
              class="btn btn-danger btn-micro float-right mt-4"
              permission="language-delete"
              @click="$emit('delete', languageCopy.id)"
            >
              Delete
            </auth-button>
          </div>
        </div>
      </div>
      <div
        slot="body"
        class="card-text"
      >
        <field-input
          v-model="languageCopy.code"
          name="languageCode"
          label="Language code"
        />
      </div>
    </card-default>
  </div>
</template>

<script>
import CardDefault from '@/components/CardDefault'
import FieldInput from '@/components/form/FieldInput'

export default {
  name: 'LanguagesForm',
  components: {
    CardDefault,
    FieldInput
  },
  props: {
    language: {
      type: Object,
      required: true
    }
  },
  computed: {
    languageCopy: {
      get () {
        return this.language
      }
    }
  }
}
</script>
